import {observer} from 'mobx-react-lite';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import CustomerQuoteFormStore from '../FormStore';

const QuoteCarrierField = observer(({state}: {state: CustomerQuoteFormStore}) => {
    const {quoteCarrier, quoteErrors} = state;
    const error = quoteErrors.get('user_selected_perm_carrier');
    return (
        <FormControl margin="normal" required fullWidth error={!!error}>
            <InputLabel>Permanent Carrier</InputLabel>
            <Select
                defaultValue={quoteCarrier?.carrier}
                onChange={({target: {value}}) => state.setQuote('user_selected_perm_carrier', value)}
            >
                {quoteCarrier?.options?.map((carrier) => (
                    <MenuItem key={carrier} value={carrier}>
                        {carrier}
                    </MenuItem>
                ))}
            </Select>
            {!!error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    );
});

export default QuoteCarrierField;
